__turbopack_context__.v({
  "multi_livestream__schedule__datepicker": "DatePicker-module-scss-module__k_NuQq__multi_livestream__schedule__datepicker",
});
